import type { Label } from 'modules/global/typing/common/Label';
import type { PublicUserGroup } from 'modules/userGroups/types/public-user-group';
import type { BasicUser } from 'modules/users/types/projections/basic-user';

export type InspectionTypeEnum = 'AUDIT' | 'TIRE_SCAN' | 'TIRE_QUOTE' | 'BODY_SCAN' | 'EXTERNAL_AUDIT';

// TODO: BE types `status` as a plain string (AuditStatusEnum); only the AUDIT inspection carries one.
//       Not published in @arhs-fleetback/types — keep this local narrowing.
export const InspectionStatusEnum = {
  DRAFT: 'DRAFT',
  TO_START: 'TO_START',
  OPEN: 'OPEN', // COMPLETED 🤷‍♂️
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
} as const;

export type InspectionStatusEnum = (typeof InspectionStatusEnum)[keyof typeof InspectionStatusEnum];

/**
 * Normalized inspection projection (union of the BE `Inspection` subclasses:
 * Audit / BodyScan / ExternalAudit / TireQuote / TireScan). Fields that only
 * some subclasses set are optional.
 */
export type Inspection = {
  assignedUser?: BasicUser;
  assignedUserGroup?: PublicUserGroup;
  createdOn: string;
  createdById?: string;
  createdFrom?: 'CHECKLIST' | 'ENTITY';
  id: string;
  imported: boolean;
  mediaCount?: number;
  modelName?: Label;
  reference?: string;
  reportUrl?: string;
  status?: InspectionStatusEnum;
  type: InspectionTypeEnum;
};
